/**
 * Stock System — respawn, invulnerability, and HUD constants.
 * Only active in vs_local and vs_online modes.
 */

export const STOCKS = {
  /** Starting stocks per player per round */
  DEFAULT_COUNT: 3,
  /** Frames after death before respawn (2 seconds at 60fps) */
  RESPAWN_DELAY_FRAMES: 120,
  /** Frames of post-respawn invulnerability (3 seconds at 60fps) */
  RESPAWN_INVULN_FRAMES: 180,
  /** Flash interval during invulnerability (frames per toggle) */
  RESPAWN_FLASH_INTERVAL: 6,
  /** Alpha when flashing low during invuln */
  FLASH_ALPHA_LOW: 0.3,
  /** Alpha when flashing high during invuln */
  FLASH_ALPHA_HIGH: 1.0,
  /** Stage-fraction X positions for respawn candidates */
  RESPAWN_POSITIONS: [0.1, 0.25, 0.4, 0.5, 0.6, 0.75, 0.9] as readonly number[],
} as const;
